import React, { useState, useEffect } from 'react';

export default function WaitingScreen({ roomCode, viewerCount, eventMode, eventName, celebration }) {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(d => d.length >= 3 ? '' : d + '.');
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const watcherNoun = celebration
    ? (viewerCount === 1 ? 'guest' : 'guests')
    : (viewerCount === 1 ? 'buyer' : 'buyers');

  return (
    <div className="screen">
      <div style={{ fontSize: 52, marginBottom: 16 }}>{celebration ? '🎉' : '👁'}</div>
      <div className="brand">{eventMode ? eventName : 'Peekr'}</div>

      <div className="room-label">{celebration ? "YOU'RE INVITED" : eventMode ? 'SHOWING' : "YOU'RE IN"}</div>
      <div className="room-code">{roomCode}</div>

      <div className="viewer-badge">
        <span className="pulse" />
        {viewerCount} {watcherNoun} watching
      </div>

      <div className="tagline">
        {celebration
          ? <>Waiting for the host<br />to go live{dots}</>
          : <>Waiting for the agent<br />to start the showing{dots}</>}
      </div>

      <div className="card" style={{
        marginTop: 32, padding: '20px',
        maxWidth: 320, width: '100%'
      }}>
        <div style={{ fontSize: 12, color: '#6A85A0', marginBottom: 8, textAlign: 'center' }}>
          Keep this screen open
        </div>
        <div style={{ fontSize: 13, color: '#3A5570', textAlign: 'center', lineHeight: 1.6 }}>
          {celebration
            ? 'The live video will appear here automatically the moment it starts. No need to refresh.'
            : 'The showing will appear here automatically when the agent starts. No need to refresh.'}
        </div>
      </div>
    </div>
  );
}
